import { render, staticRenderFns } from "./ActionLinkContent.vue?vue&type=template&id=5b642cd0&"
import script from "./ActionLinkContent.vue?vue&type=script&lang=ts&"
export * from "./ActionLinkContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports